import { render } from "./masterDataSync.vue?vue&type=template&id=82c427f8"
import script from "./masterDataSync.vue?vue&type=script&lang=js"
export * from "./masterDataSync.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__